export const getCurrentTimeInSeconds = (): number => new Date().getTime() / 1000 || 0;
